import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import React, { useRef, useState } from "react";
import makeClasses from "./styles";
import { useSelector } from "react-redux";
import { Language } from "../../utils";
import Markdown from "markdown-to-jsx";
import Button from "../Button";
import RadioGroupComponent from "../RadioGroup";
import { Publish as UploadIcon } from "@material-ui/icons";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const NoTCModal = ({ open, onClose, onSave }) => {
  const classes = makeClasses();
  const [useHandyTemplate, setUseHandyTemplate] = useState(false);
  const [selectedTyCOption, setSelectedTyCOption] = useState("");
  const uploadInputRef = useRef(null);
  const { languageTexts } = useSelector(({ language }) => ({
    languageTexts: language.texts || {},
  }));
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const i18n = Language(languageTexts);

  const handleOnFileUpload = (e) => {
    const files = e.currentTarget.files;
    const fileName = files[0]?.name;
    setFileName(fileName);
    setFile(files[0]);
  };

  const handleSave = async () => {
    let uploadFile = file;
    if (useHandyTemplate) {
      const response = await fetch("/handy_tc.pdf");
      const blob = await response.blob();
      uploadFile = new File([blob], "handy_tc.pdf", {
        type: "application/pdf",
      });
    }

    onSave({ file: uploadFile, selectedTyCOption });
    onClose();
  };

  const handleTyCOptionChange = (value) => {
    setSelectedTyCOption(value);
    setFileName("");
    setUseHandyTemplate(false);
    setFile(null);
  };

  const handleOnUseHandyTemplateCheck = () => {
    setFile(null);
    setFileName("");
    setUseHandyTemplate(!useHandyTemplate);
  };

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.dialogTitleWrapper}>
        <div className={classes.dialogTitle}>
          {i18n.get("Components.NoTCModal.HeaderTitle")}
        </div>
      </DialogTitle>
      <DialogContent className={classes.dialogContentWrapper}>
        <div className={classes.dialogContent}>
          <Markdown>{i18n.get("Components.NoTCModal.BodyText")}</Markdown>
          <RadioGroupComponent
            onChange={handleTyCOptionChange}
            value={selectedTyCOption}
            options={[
              {
                label: i18n.get("Components.NoTCModal.Branch"),
                value: "branch",
                description: i18n.get("Components.NoTCModal.BranchDescription"),
                additionalInput: (
                  <div className={classes.inputFileContainer}>
                    <div className={classes.inputFile}>
                      <input
                        ref={uploadInputRef}
                        id="file"
                        type="file"
                        accept="application/pdf"
                        onChange={handleOnFileUpload}
                      />
                      <label htmlFor="file">
                        <div>
                          {i18n.get("Components.NoTCModal.FileInputLabel")}
                        </div>
                        {fileName && fileName.length > 0
                          ? fileName
                          : i18n.get(
                              "Components.NoTCModal.FileInputPlaceholder"
                            )}
                        <div className={classes.inputFileIcon}>
                          <UploadIcon fontSize="small" />
                        </div>
                      </label>
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={useHandyTemplate}
                          onChange={handleOnUseHandyTemplateCheck}
                        />
                      }
                      label={i18n.get(
                        "Components.NoTCModal.HandyBasicTemplate"
                      )}
                      classes={{ label: classes.autoApprovalLabel }}
                    />
                  </div>
                ),
                disabled: false,
              },
              {
                label: i18n.get("Components.NoTCModal.Plan"),
                value: "plan",
                description: i18n.get("Components.NoTCModal.PlanDescription"),
                disabled: false,
                additionalInput: (
                  <div className={classes.inputFile}>
                    <input
                      ref={uploadInputRef}
                      id="file"
                      type="file"
                      accept="application/pdf"
                      onChange={handleOnFileUpload}
                    />
                    <label htmlFor="file">
                      <div>
                        {i18n.get("Components.NoTCModal.FileInputLabel")}
                      </div>
                      {i18n.get("Components.NoTCModal.FileInputPlaceholder")}
                      <div className={classes.inputFileIcon}>
                        <UploadIcon fontSize="small" />
                      </div>
                    </label>
                  </div>
                ),
              },
            ]}
          />
        </div>
      </DialogContent>
      <DialogActions className={classes.dialogActionsWrapper}>
        <Button disabled={!useHandyTemplate && !file} onClick={handleSave}>
          {i18n.get("Components.NoTCModal.SaveButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoTCModal;
